__turbopack_context__.v({
  "background-image": "CorePeopleHero-module-scss-module__2JPWxW__background-image",
  "contact-info": "CorePeopleHero-module-scss-module__2JPWxW__contact-info",
  "contact-info-section": "CorePeopleHero-module-scss-module__2JPWxW__contact-info-section",
  "container": "CorePeopleHero-module-scss-module__2JPWxW__container",
  "content": "CorePeopleHero-module-scss-module__2JPWxW__content",
  "email-formatted": "CorePeopleHero-module-scss-module__2JPWxW__email-formatted",
  "email-link": "CorePeopleHero-module-scss-module__2JPWxW__email-link",
  "fallback-background": "CorePeopleHero-module-scss-module__2JPWxW__fallback-background",
  "fax-link": "CorePeopleHero-module-scss-module__2JPWxW__fax-link",
  "file-icon": "CorePeopleHero-module-scss-module__2JPWxW__file-icon",
  "file-link": "CorePeopleHero-module-scss-module__2JPWxW__file-link",
  "file-links": "CorePeopleHero-module-scss-module__2JPWxW__file-links",
  "files": "CorePeopleHero-module-scss-module__2JPWxW__files",
  "grid": "CorePeopleHero-module-scss-module__2JPWxW__grid",
  "image-container": "CorePeopleHero-module-scss-module__2JPWxW__image-container",
  "info": "CorePeopleHero-module-scss-module__2JPWxW__info",
  "info-label": "CorePeopleHero-module-scss-module__2JPWxW__info-label",
  "linked-in-wrapper": "CorePeopleHero-module-scss-module__2JPWxW__linked-in-wrapper",
  "linkedin-icon": "CorePeopleHero-module-scss-module__2JPWxW__linkedin-icon",
  "linkedin-link": "CorePeopleHero-module-scss-module__2JPWxW__linkedin-link",
  "main": "CorePeopleHero-module-scss-module__2JPWxW__main",
  "name": "CorePeopleHero-module-scss-module__2JPWxW__name",
  "office-info": "CorePeopleHero-module-scss-module__2JPWxW__office-info",
  "office-item": "CorePeopleHero-module-scss-module__2JPWxW__office-item",
  "office-link": "CorePeopleHero-module-scss-module__2JPWxW__office-link",
  "offices": "CorePeopleHero-module-scss-module__2JPWxW__offices",
  "pdf": "CorePeopleHero-module-scss-module__2JPWxW__pdf",
  "pdf-background-image": "CorePeopleHero-module-scss-module__2JPWxW__pdf-background-image",
  "pdf-background-image--full-width": "CorePeopleHero-module-scss-module__2JPWxW__pdf-background-image--full-width",
  "pdf-link": "CorePeopleHero-module-scss-module__2JPWxW__pdf-link",
  "phone-info": "CorePeopleHero-module-scss-module__2JPWxW__phone-info",
  "phone-item": "CorePeopleHero-module-scss-module__2JPWxW__phone-item",
  "phone-link": "CorePeopleHero-module-scss-module__2JPWxW__phone-link",
  "profile-image": "CorePeopleHero-module-scss-module__2JPWxW__profile-image",
  "share-section": "CorePeopleHero-module-scss-module__2JPWxW__share-section",
  "title": "CorePeopleHero-module-scss-module__2JPWxW__title",
});
